import React from "react";
import APP_CONSTANTS, {
  PLACEHOLDER_OPTION,
  OPERAND2_PRE_TYPES,
  METADATA_DISPLAY_TYPES,
  FORM_RULE_CONDITIONAL,
  FILTERING_CONDITIONAL,
  FA_VALUE_DATA_STRUCTURE_TYPES,
  INPUT_FORM_ATTRIBUTE_TYPES
} from  '../../shared/constants/app_constants';
import CONDITION_OPERATORS, { 
  SYSTEM_OPERATORS,
  FILTERING_CONDITION_OPERATORS
} from "../../shared/constants/operation_constants";
import FormAttributeSelectorWithMetadata from './FormAttributeSelectorWithMetadata';

const SINGLE_VALUE_FA_TYPES = [
  APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.FREEFORM,
  APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.SINGLESELECT
];
const NUMBER_VALUE_TYPES = [
  APP_CONSTANTS.VALUE_TYPES.INTEGER,
  APP_CONSTANTS.VALUE_TYPES.FLOAT,
  APP_CONSTANTS.VALUE_TYPES.CURRENCY
];

const FORM_RULE_CONDITIONALS_ATTRIBUTES = "form_rule_conditionals_attributes";
const FILTERING_CONDITIONALS_ATTRIBUTES = "filtering_conditionals_attributes";

export default class ConditionExpressionManager extends React.Component{

  getConditionalTypeNamespace = () => {
    return (this.props.conditional_type === FILTERING_CONDITIONAL ? 
      FILTERING_CONDITIONALS_ATTRIBUTES : FORM_RULE_CONDITIONALS_ATTRIBUTES );
  }

  getFormAttributesForOperand1 = (forFilteringRule = false) => {
    const conditional = this.props.conditional,
      keenform = this.props.keenform,
      form_rule = this.props.form_rule;
    if (forFilteringRule) {
      return keenform.form_attributes.filter((fa) => {
        return form_rule.target_attribute_ids.includes(fa.id);
      });
    } else {
      return keenform.form_attributes.filter(fa => {
        return INPUT_FORM_ATTRIBUTE_TYPES.includes(fa.form_attribute_type);
      });
    }
  }

  getOperatorsPerOperand = (isMetadata = false) => {
    let operatorOptions = [];
    switch (this.props.conditional_type) {
      case FORM_RULE_CONDITIONAL:
        operatorOptions = this.getOperatorsForFormRuleConditionalsPerOperand(isMetadata);
        break
      case FILTERING_CONDITIONAL:
        operatorOptions = this.getOperatorsForFilteringConditionalsPerOperand(isMetadata);
        break;
      default:
        console.warn('unaccounted for conditional', this.props.conditional_type);
    }
    return operatorOptions;
  }

  getOperatorsForFormRuleConditionalsPerOperand = (isMetadata = false) => {
    let operatorOptions = [];
    const conditional = this.props.conditional;
    const form_attributes = this.props.keenform.form_attributes;
    const operand1FA = form_attributes.find(fa => fa.uuid === conditional.operand1_uuid);
    if ( !!operand1FA ) {
      // need to check metadata type
      if (isMetadata === false) {
        switch( operand1FA.form_attribute_type ){
          case APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.FREEFORM:
            if ( NUMBER_VALUE_TYPES.includes(operand1FA.value_type) ) {
              operatorOptions = CONDITION_OPERATORS.FREEFORM.NUMBER;
            } else {
              operatorOptions = CONDITION_OPERATORS.FREEFORM.TEXT;
            }
            break;
          case APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.SINGLESELECT:
            operatorOptions = CONDITION_OPERATORS.SINGLESELECT;
            break;
          case APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.MULTISELECT:
            operatorOptions = CONDITION_OPERATORS.MULTISELECT;
            break;
          default:
            console.error('invalid form attribute display type');
        }
      } else {
        const metadataType = operand1FA.metadata_types.find(mdt => mdt.uuid === this.props.conditional.operand1_value_type);
        switch( metadataType.display_type ) {
          case METADATA_DISPLAY_TYPES.TEXT:
            if (operand1FA.form_attribute_type === APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.SINGLESELECT) {
              operatorOptions = CONDITION_OPERATORS.FREEFORM.TEXT;
            } else if ( operand1FA.form_attribute_type === APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.MULTISELECT ) {
              // TODO: under construction
              console.warn('this is not possible yet');
              operatorOptions = [];
            } else {
              console.error('invalid form attribute type');
            }
            break;
          case METADATA_DISPLAY_TYPES.NUMBER:
            if (operand1FA.form_attribute_type === APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.SINGLESELECT) {
              operatorOptions = CONDITION_OPERATORS.FREEFORM.NUMBER;
            } else if ( operand1FA.form_attribute_type === APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.MULTISELECT ) {
              // TODO: under construction
              console.warn('this is not possible yet');
              operatorOptions = [];
            } else {
              console.error('invalid form attribute type');
            }
            break;
          case METADATA_DISPLAY_TYPES.SINGLESELECT:
            if (operand1FA.form_attribute_type === APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.SINGLESELECT) {
              operatorOptions = CONDITION_OPERATORS.SINGLESELECT;
            } else if ( operand1FA.form_attribute_type === APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.MULTISELECT ) {
              operatorOptions = CONDITION_OPERATORS.MULTISELECT;
            } else {
              console.error('invalid form attribute type');
            }
            break;
          default:
            console.error('invalid metadata type display type');
        }
      }
    }
    // if operand1 is NOT metadata then add system operators
    if (conditional.operand1_value_type === "value") {
      operatorOptions = operatorOptions.concat(SYSTEM_OPERATORS);
    }
    return operatorOptions
  }

  // TODO: this needs work - Form attribute type is ALWAYS SINGLE or MULTI Select, metadata requires more effort
  getOperatorsForFilteringConditionalsPerOperand = (isMetadata = false) => {
    let operatorOptions = [];
    const conditional = this.props.conditional;
    const form_attributes = this.props.keenform.form_attributes;
    const operand1FA = form_attributes.find(fa => fa.uuid === conditional.operand1_uuid);
    if ( !!operand1FA ) {
      if (isMetadata === false) {
        switch (operand1FA.form_attribute_type) {
          case APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.SINGLESELECT:
            operatorOptions = FILTERING_CONDITION_OPERATORS.SINGLESELECT;
            break;
          case APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.MULTISELECT:
            operatorOptions = FILTERING_CONDITION_OPERATORS.SINGLESELECT;
            break;
          default:
            console.warn('this is not supposed to happen');
        }
      } else { // this is metadata
        const metadataType = operand1FA.metadata_types.find(mdt => mdt.uuid === this.props.conditional.operand1_value_type);
        switch( metadataType.display_type ) {
          case METADATA_DISPLAY_TYPES.TEXT:
            // TODO: need special operators for finding a single val in another multiselect
            operatorOptions = CONDITION_OPERATORS.FREEFORM.TEXT.concat(FILTERING_CONDITION_OPERATORS.TEXT);
            break;
          case METADATA_DISPLAY_TYPES.NUMBER:
            operatorOptions = CONDITION_OPERATORS.FREEFORM.NUMBER.concat(FILTERING_CONDITION_OPERATORS.NUMBER);
            break;
          case METADATA_DISPLAY_TYPES.SINGLESELECT:
            operatorOptions = FILTERING_CONDITION_OPERATORS.SINGLESELECT;
            break;
          default:
            console.warn('this is not supposed to happen');
        }
      }
    } else {
      console.error('cannot find matching form attribute!');
    }
    return operatorOptions;
  }

  // get operator object from operator key
  getOperatorObject = (operatorKey) => {
    let operatorSet, operatorObject;
    if ( !!operatorKey ) {
      if (operatorKey.startsWith('STRING') ) {
        operatorSet = CONDITION_OPERATORS.FREEFORM.TEXT;
      } else if ( operatorKey.startsWith('NUMBER') ) {
        operatorSet = CONDITION_OPERATORS.FREEFORM.NUMBER;
      } else if ( operatorKey.startsWith('SINGLESELECT') ) {
        operatorSet = CONDITION_OPERATORS.SINGLESELECT;
      } else if ( operatorKey.startsWith('MULTISELECT') ) {
        operatorSet = CONDITION_OPERATORS.MULTISELECT;
      } else if ( operatorKey.startsWith('LAST_USER_MODIFIED_FA') ) {
        operatorSet = SYSTEM_OPERATORS;
      } else if ( operatorKey.startsWith('FILTERING') ) {
        operatorSet = FILTERING_CONDITION_OPERATORS.SINGLESELECT;
      } else {
        console.warn('we seem to be missing a valid operator set');
      }
      if (!!operatorSet) {
        operatorObject = operatorSet.find(op => op.value === operatorKey);
      }

      if (!!operatorObject) {
        return operatorObject;
      } else {
        console.warn('cannot find matching operator object');
        return undefined;
      }
    } else {
      console.warn('operator key is blank');
      return undefined;
    }
  }

  isUsingMetadata = () => {
    let isUsingMetadata = false;
    if (!!this.props.conditional.operand1_uuid 
      && !!this.props.conditional.operand1_value_type
      && this.props.conditional.operand1_value_type !== 'value' ){
        isUsingMetadata = true;
    }
    return isUsingMetadata;
  }

  /**
   * Returns list of options available to operand1 selected, either form attribute or metadata options
   * @returns {options[]} optionArray - the options available based on operand 1 form attribute
   */
  getSelectableOptionsForOperand2 = () => {
    // const inputNamespace = this.getConditionalTypeNamespace();
    const conditional = this.props.conditional;
    const formAttribute = this.props.keenform.form_attributes.find(fa => fa.uuid === conditional.operand1_uuid);
    const usingMetadata = this.isUsingMetadata();

    if (formAttribute) {
      let options = formAttribute.options;
      if (usingMetadata) { // replace options with metadata type options
        const metadataType = formAttribute.metadata_types.find(mdt => mdt.uuid === conditional.operand1_value_type);
        if (!!metadataType) {
          if ( metadataType.hasOwnProperty('selectable_uuid') && !!metadataType.selectable_uuid) { 
            const matchingFA = this.props.keenform.form_attributes.find(fa => fa.uuid === metadataType.selectable_uuid);
            options = matchingFA.options;
          } else if (metadataType.options){
            options = metadataType.options;
          } else {
            console.error('this should not happen');
          }
        } else {
          console.error('missing metadata type');
        }
      }
      let optionArray = [].concat(options);
      if (formAttribute.placeholder){
        const placeholderOption = {
          label: formAttribute.placeholder,
          value: PLACEHOLDER_OPTION,
          uuid: PLACEHOLDER_OPTION
        };
        optionArray.unshift(placeholderOption);
      }
      return optionArray;
    } else {
      console.warn('cannot find form attribute referenced for this form rule', this.props);
      return [];
    }

  }

  /**
   * Sets value of conditional.operand2_option_values based on event
   * @param {*} option_selected 
   */
  setOperand2ForOptionValues = (option_selected) => {
    const conditional = this.props.conditional;
    
    let updatedConditional = {
      ...conditional,
    };
    if (!!updatedConditional.operand2_option_values){
      if (updatedConditional.operand2_option_values.includes(option_selected)){ // remove option_selected
        updatedConditional.operand2_option_values = conditional.operand2_option_values.filter(opt => opt != option_selected);
      } else { // add this option_selected
        updatedConditional.operand2_option_values.push(option_selected);
      }
    } else {
      console.log('THIS SHOULD NOT HAPPEN, but compensate');
      updatedConditional.operand2_option_values = [option_selected];
    }
    this.props.onUpdateAction(updatedConditional);
  }

  /**
   * set value for conditional.operand2_option_value
   * @param {*} event 
   */
  setOperand2ForOptionValueSingle = (event) => {
    const conditional = this.props.conditional;
    let updatedConditional = {
      ...conditional,
      operand2_option_value: event.target.value
    };
    this.props.onUpdateAction(updatedConditional);
  }

  setOperator(event) {
    let operatorValue = event.target.value;
    if (event.target.value === PLACEHOLDER_OPTION){ // PLACEHOLDER_OPTION
      operatorValue = undefined;
    }
    let updatedConditional = {
      ...this.props.conditional,
      operator: operatorValue
    };
    /**
     * if operand2Type does not exist, then add it
     */

    this.props.onUpdateAction(updatedConditional);
  }

  setOperand2PreType = (event) => {
    // make this the function that updates the whole conditional
    const conditional = this.props.conditional;
    const operand2_pre_type = event.target.value;
    // if this is an option available for this form attribute
    // then add new attribute to conditional operand2_option_values
    // else if this is equal to another form attribute value (including metadata)
    // then add new attribute to conditional operand2_value
    
    const updatedConditional = {
      ...conditional,
      operand2_pre_type: operand2_pre_type
    };

    switch(operand2_pre_type){
      case OPERAND2_PRE_TYPES.FIXED_TEXT:
        updatedConditional.operand2_fixed_text = "";
        break;
      case OPERAND2_PRE_TYPES.FIXED_INTEGER:
        updatedConditional.operand2_fixed_integer = undefined;
        break;
      case OPERAND2_PRE_TYPES.FIXED_FLOAT:
        updatedConditional.operand2_fixed_float = undefined;
        break;
      case OPERAND2_PRE_TYPES.FORM_ATTRIBUTE_VALUE:
        updatedConditional.operand2_fa_uuid = PLACEHOLDER_OPTION;
        break;
      case OPERAND2_PRE_TYPES.OPTION_VALUES:
        updatedConditional.operand2_option_values = [];
        break;
      case OPERAND2_PRE_TYPES.OPTION_VALUE:
        updatedConditional.operand2_option_value = undefined;
        break;
      default:
        // this might happen when a value is unset
        console.warn('this might happen when a value is unset, operand2_pre_type:', operand2_pre_type);
    }

    this.props.onUpdateAction(updatedConditional);
  }

  // hide operator if this is selectable but has no options OR
  // this operator requiresOperand isnt true
  showOperatorPerOperand1(){
    const operand1FA = this.props.keenform.form_attributes.find(fa => fa.uuid === this.props.conditional.operand1);
    let showOperator = false;
    if ( !!operand1FA ) {
      if (!this.props.conditional.operand1Metadata || this.props.conditional.operand1Metadata === null ) {
        switch(operand1FA.form_attribute_type){
          case APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.FREEFORM:
            showOperator = true;
            break;
          case APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.SINGLESELECT:
          case APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.MULTISELECT:
            showOperator = operand1FA.options.length > 0;
            break;
        }
      } else { // use metadata instead
        const thisMetadataType = operand1FA.metadata_types.find(mdt => mdt.uuid === this.props.conditional.operand1Metadata);
        if (!!thisMetadataType) {
          switch(thisMetadataType.display_type) {
            case METADATA_DISPLAY_TYPES.TEXT:
            case METADATA_DISPLAY_TYPES.NUMBER:
            case METADATA_DISPLAY_TYPES.SINGLESELECT:
              showOperator = true;
              break;
            default:
              console.warn('invalid metadata type, no operator to show');
          }
        }
      }
    }
    return showOperator;
  }

  updateCondition(attributeName, attributeValue){
    let updatedConditional = {...this.props.conditional};
    updatedConditional[attributeName] = attributeValue;
    this.props.onUpdateAction(updatedConditional);
  }

  updateOperand1 = (event) => {
    const conditional = this.props.conditional;
    let operand1_uuid,
      operand1_value_type,
      updatedConditional;
    
    if (!!event.target.value && event.target.value.split(".").length === 2) { // as long as its not false
      const valueArr = event.target.value.split(".");
      operand1_uuid = valueArr[0],
      operand1_value_type = valueArr[1];

      updatedConditional = {
        ...conditional,
        operand1_uuid: operand1_uuid,
        operand1_value_type: operand1_value_type,
        operator: undefined,
        operand2_pre_type: undefined
      };
    } else {
      updatedConditional = {
        ...conditional,
        operand1_uuid: undefined,
        operand1_value_type: undefined,
        operator: undefined,
        operand2_pre_type: undefined
      }
    }

    this.props.onUpdateAction(updatedConditional);
  }

  renderOperand1Select = () => {
    const conditional = this.props.conditional,
      keenform = this.props.keenform,
      form_rule = this.props.form_rule;
    const isFilteringRule = this.props.conditional_type === FILTERING_CONDITIONAL;
    const selectableFormAttributes = this.getFormAttributesForOperand1(isFilteringRule);
    return <FormAttributeSelectorWithMetadata
      conditional={conditional}
      index={this.props.conditional.index}
      inputName="operand1"
      selectableOptions={selectableFormAttributes}
      onUpdateEvent={this.updateOperand1}
      matchingValueType={null}
      val1={conditional.operand1_uuid}
      val2={conditional.operand1_value_type}
      form_attributes={this.props.keenform.form_attributes}
      />;
  }

  updateOperand2 = (event) => {
    const conditional = this.props.conditional;
    let operand2_uuid,
    operand2_value_type,
    updatedConditional;

    if (!!event.target.value && event.target.value.split(".").length === 2) { // as long as its not false
      const valueArr = event.target.value.split(".");
      operand2_uuid = valueArr[0],
      operand2_value_type = valueArr[1];

      updatedConditional = {
        ...conditional,
        operand2_uuid: operand2_uuid,
        operand2_value_type: operand2_value_type
      };
    } else {
      updatedConditional = {
        ...conditional,
        operand2_uuid: undefined,
        operand2_value_type: undefined
      }
    }

    this.props.onUpdateAction(updatedConditional);
  }

  updateOperand2FixedText = (event) => {
    const conditional = this.props.conditional;
    const updatedConditional = {
      ...conditional,
      operand2_fixed_text: event.target.value
    }
    this.props.onUpdateAction(updatedConditional);
  }

  updateOperand2FixedNumber = (event) => {
    const conditional = this.props.conditional,
    operand2FixedValType  = conditional.operand2_pre_type;
    // make this either fixed_integer or fixed_float
    let updatedConditional = { ...conditional };
    if (operand2FixedValType === OPERAND2_PRE_TYPES.FIXED_INTEGER) {
      updatedConditional.operand2_fixed_integer = event.target.value;
    } else if (operand2FixedValType === OPERAND2_PRE_TYPES.FIXED_FLOAT ){
      updatedConditional.operand2_fixed_float = event.target.value;
    } else {
      // are we missing currency?
      console.warn('this should not be');
    }
    this.props.onUpdateAction(updatedConditional);
  };

  renderOperand1Inputs = () => {
    const inputNamespace = this.getConditionalTypeNamespace();
    const conditional = this.props.conditional;
    // const operand1FA = this.props.keenform.form_attributes.find(fa => fa.uuid === conditional.operand1_uuid);
    if (!conditional.operand1_uuid){
      return undefined;
    }

    return (
      <React.Fragment>
        <input 
          type="hidden"
          readOnly
          name={`form_rule[${inputNamespace}][${conditional.index}][operand1_uuid]`} 
          value={conditional.operand1_uuid || ""} />
        <input 
          type="hidden"
          readOnly
          name={`form_rule[${inputNamespace}][${conditional.index}][operand1_value_type]`}
          value={conditional.operand1_value_type || ""} />
        { conditional.id 
          ? <input 
              type="hidden" 
              name={`form_rule[${inputNamespace}][${conditional.index}][id]`}
              value={conditional.id} />
          : undefined
        }
        {
          conditional._destroy
          ? <input type="hidden" 
              name={`form_rule[${inputNamespace}][${conditional.index}][_destroy]`}
              value="1" />
          : undefined
        }
      </React.Fragment>
    );
  }

  // TODO - accomodate for METADATA, change function name render operator 2 options for singleselect
  renderOperand2OptionsForSingleSelect = () => {
    const inputNamespace = this.getConditionalTypeNamespace();
    const conditional = this.props.conditional;

    const optionArray = this.getSelectableOptionsForOperand2();
    if (optionArray.length === 0 ) {
      return <div className="alert alert-warning">No options available</div>;
    } else {
      return (<div className="form-group">
      <select
         className="form-control condition-input condition-operator-input"
         name={`form_rule[${inputNamespace}][${conditional.index}][operand2_option_value]`}
         onChange={this.setOperand2ForOptionValueSingle}
         value={conditional.operand2_option_value}>
        <option value={undefined}>select an option</option>
        {optionArray.map((option, i) => {
          return (<option 
            key={i}
            value={option.uuid}>
              {option.value}</option>);
        })}
      </select>
    </div>);
    }
  }

  renderOperand2OptionsForMultiSelect = () => {
    const inputNamespace = this.getConditionalTypeNamespace();
    const conditional = this.props.conditional;
    const optionArray = this.getSelectableOptionsForOperand2();
    if (optionArray.length === 0 ) {
      return <div className="alert alert-warning">No options available for condition selected</div>;
    } else {
      return (<div className="container-operand-options">
      {optionArray.map((option, index) => {
        let optionSelected = false;
        if (!!conditional.operand2_option_values && Array.isArray(conditional.operand2_option_values)){
          optionSelected = conditional.operand2_option_values.includes(option.uuid);
        } else {
          console.warn('something is wrong with the conditional option values: ', conditional);
        }
        const displayedLabel = !!option.label ? option.label : option.value;
        return (<div
          key={index}
          onClick={() => {this.setOperand2ForOptionValues(option.uuid)}}
          className={`container-operand-option ${optionSelected ? 'selected' : ''}`}>
            { 
              optionSelected
             ? <i className="fas fa-check-square"></i> 
             : <i className="far fa-square"></i> 
            }
            <span className="operand2-option-label">{displayedLabel}</span>
            { 
              optionSelected 
              ? <input 
                type="hidden"
                name={`form_rule[${inputNamespace}][${this.props.conditional.index}][operand2_option_values][]`}
                value={option.uuid} />
              : undefined
            }
        </div>);
      }) }
    </div>);
    }
  }

  renderOperandOneWithMetadata = () => {
    const conditional = this.props.conditional,
    operand1_uuid = conditional.operand1_uuid,
    operand1_value_type = conditional.operand1_value_type;

    let proxyValue = PLACEHOLDER_OPTION;
    if (operand1_uuid != undefined && operand1_value_type != undefined){
      proxyValue = `${operand1_uuid}.${operand1_value_type}`;
    }

    return (<select 
      className="form-control condition-input condition-operand1-input"
      name={`${conditional.index}`}
      value={proxyValue}
      onChange={(event) => { this.updateOperand1(event) }}>
      <option value={PLACEHOLDER_OPTION}>Select an attribute</option>
      {
        this.props.keenform.form_attributes
        .filter(fa => ["freeform", "singleselect", "multiselect"].includes(fa.form_attribute_type) )
        .map((form_attribute, index) => {
          if (!form_attribute.metadata_types) {
            return (<option 
              value={`${form_attribute.uuid}.value`}
              key={index}>
                {form_attribute.label} value
              </option>);
          } else {
            const faValue = `${form_attribute.uuid}.value`;
            return <optgroup label={form_attribute.label} key={form_attribute.id}>
              <option
                value={faValue}>{form_attribute.name} value</option>
              { form_attribute.metadata_types.map((metadataType, index) => {
                const compoundValue = form_attribute.uuid + "." + metadataType.uuid;
                return <option 
                  key={index}
                  value={compoundValue}>
                    {form_attribute.name}.{metadataType.name}
                  </option>;
              })}
            </optgroup>;
          }
        })
      }
    </select>);
  }

  renderOperators = () => {
    const namespace = this.getConditionalTypeNamespace();
    const conditional = this.props.conditional;
    if (conditional.operand1_uuid == undefined) {
      return undefined;
    }
    const usingMetadata = this.isUsingMetadata();
    // separate operators for form attributes versus METADATA
    const operatorOptions = this.getOperatorsPerOperand(usingMetadata);
    const operatorValue = (conditional.operator === undefined ? PLACEHOLDER_OPTION : conditional.operator);
    // add new option for multiselect
    if (operatorOptions.length > 0 ) {
      return (
        <select 
          className="form-control condition-input condition-operator-input"
          name={`form_rule[${namespace}][${conditional.index}][operator]`}
          value={operatorValue}
          onChange={(event)=>{ this.setOperator(event)}}>
          <option value={PLACEHOLDER_OPTION}>select a condition type...</option>
          { operatorOptions.map((operator, index) => {
              const opLabel = (operator.hasOwnProperty('operatorSymbol') ? `${operator.operatorSymbol} (${operator.label})` : operator.label);
              return (<option 
                value={operator.value}
                key={index}>
                  {opLabel}
                </option>);
            }) }
        </select>);
    } else {
      return <div className="alert alert-warning">Currently there are no valid operators for this form attribute data type</div>;
    }
  }

  renderOperand2TypeForFreeform = (value_type) => {
    const namespace = this.getConditionalTypeNamespace();
    const conditional = this.props.conditional;
    const useMetadata = (conditional.operand1_value_type !== "value");
    const operatorOptions = this.getOperatorsPerOperand(useMetadata);
    const operatorObject = operatorOptions.find(operator => {
      return operator.value === conditional.operator
    });

    let matchingValueType = "text value",
    staticOperand2TypeVal = OPERAND2_PRE_TYPES.FIXED_TEXT,
    matchValueType = value_type;
    if (operatorObject && operatorObject.hasOwnProperty('operand2AbstractValueType') ) {
      // special operand2 per operator, not the same type as operand1
      matchValueType = operatorObject.operand2AbstractValueType;
    }

    switch(matchValueType) {
      case "integer":
        matchingValueType = "integer number";
        staticOperand2TypeVal = OPERAND2_PRE_TYPES.FIXED_INTEGER;
        break;
      case "float":
        matchingValueType = "decimal number";
        staticOperand2TypeVal = OPERAND2_PRE_TYPES.FIXED_FLOAT;
        break;
      case "currency": // should this be fixed currency instead?
        matchingValueType = "float";
        staticOperand2TypeVal = OPERAND2_PRE_TYPES.FIXED_FLOAT;
        break;
      case "number":
        matchingValueType = "number";
        if ( operatorObject.hasOwnProperty('operand2Type')
        && operatorObject.operand2Type === APP_CONSTANTS.VALUE_TYPES.INTEGER) {
          staticOperand2TypeVal = OPERAND2_PRE_TYPES.FIXED_INTEGER;
        } else {
          staticOperand2TypeVal = OPERAND2_PRE_TYPES.FIXED_INTEGER;
        }
        break;
      case "text":
        // this is redundant
        matchingValueType = "text value";
        staticOperand2TypeVal = OPERAND2_PRE_TYPES.FIXED_TEXT;
        break;
      default:
        console.error('invalid value type for fixed value, matchValueType:', matchValueType);
        return <div className="alert alert-danger">unexpected value type</div>;
    }

    const operand2PreTypeVal = conditional.operand2_pre_type === undefined ? PLACEHOLDER_OPTION : conditional.operand2_pre_type;
    return (<select 
      onChange={(event) => {this.setOperand2PreType(event)}}
      name={`form_rule[${namespace}][${conditional.index}][operand2_pre_type]`}
      value={operand2PreTypeVal}
      className="form-control condition-input">
      <option value={PLACEHOLDER_OPTION}>...select a type to compare to</option>
      <option value={staticOperand2TypeVal}>A fixed {matchingValueType}</option>
      <option value="form_attribute_value">A form attribute {matchingValueType} value</option>
    </select>);
  }

  // TODO: show options for metadata when operand1 is metadata value
  renderOperand2TypeForSelectable = () => {
    const namespace               = this.getConditionalTypeNamespace();
    const conditional             = this.props.conditional;
    const operand1FormAttribute   = this.props.keenform.form_attributes.find(fa => fa.uuid === conditional.operand1_uuid);
    const operatorObject          = this.getOperatorObject(conditional.operator);

    const optionValueLabel = `An option available for ${operand1FormAttribute.name}`;
    let options = [];

    if (operatorObject.operand2AbstractValueType === APP_CONSTANTS.ABSTRACT_VALUE_TYPES.FROM_OPERAND) {
      if (operatorObject.operand2ValueDataStructureTypeForEligibleValues === FA_VALUE_DATA_STRUCTURE_TYPES.ARRAY ) {
        options.push( { value: OPERAND2_PRE_TYPES.OPTION_VALUES, label: optionValueLabel } );
      } else if (operatorObject.operand2ValueDataStructureTypeForEligibleValues === FA_VALUE_DATA_STRUCTURE_TYPES.PRIMITIVE ) {
        options.push( { value: OPERAND2_PRE_TYPES.OPTION_VALUE, label: optionValueLabel });
      }

      if (operatorObject.operand2ValueDataStructureTypeForAnotherFormAttribute === FA_VALUE_DATA_STRUCTURE_TYPES.PRIMITIVE) {
        options.push( {value: OPERAND2_PRE_TYPES.FORM_ATTRIBUTE_VALUE, label: "Another form attribute value" } );
      } else if (operatorObject.operand2ValueDataStructureTypeForAnotherFormAttribute === FA_VALUE_DATA_STRUCTURE_TYPES.ARRAY ) {
        options.push( {value: OPERAND2_PRE_TYPES.FORM_ATTRIBUTE_VALUE, label: "Another multiselect form attribute value" });
      }
    } else if (operatorObject.operand2AbstractValueType === APP_CONSTANTS.ABSTRACT_VALUE_TYPES.NUMBER) {
      options.push({ value: OPERAND2_PRE_TYPES.FIXED_INTEGER, label: 'a fixed integer'});
      options.push( {value: OPERAND2_PRE_TYPES.FORM_ATTRIBUTE_VALUE, label: "Another form attribute value" } );
    } else {
      console.warn('operator object has unaccounted for information', operatorObject);
    }

    return (<select 
      onChange={(event) => {this.setOperand2PreType(event)}}
      name={`form_rule[${namespace}][${conditional.index}][operand2_pre_type]`}
      value={conditional.operand2_pre_type}
      className="form-control condition-input">
      <option value={PLACEHOLDER_OPTION}>...select a type to compare to</option>
      {options.map((opt, index) => <option value={opt.value} key={index}>{opt.label}</option> )}
    </select>);
  }

  renderOperand2ForFixedNumber = () => {
    const namespace = this.getConditionalTypeNamespace();
    const conditional       = this.props.conditional,
      operand2FixedValType  = 'operand2_' + conditional.operand2_pre_type;
    let fixedValue;

    if (conditional.operand2_pre_type === OPERAND2_PRE_TYPES.FIXED_INTEGER && conditional.hasOwnProperty('operand2_fixed_integer') ) {
      fixedValue = conditional.operand2_fixed_integer || "";
    } else if (conditional.operand2_pre_type === OPERAND2_PRE_TYPES.FIXED_FLOAT && !!conditional.hasOwnProperty('operand2_fixed_float') ) {
      fixedValue = conditional.operand2_fixed_float || "";
    } else {
      console.warn('unexpected value type, cannot render anything');
      return <div className="alert alert-danger">unexpected value type, please notify support</div>;
    }
    return (<div>
      <input 
        className="form-control condition-input condition-operand2-input"
        type="number"
        placeholder="enter a number value to match"
        value={fixedValue}
        onChange={(event)=>{ this.updateOperand2FixedNumber(event)}}
        name={`form_rule[${namespace}][${conditional.index}][${operand2FixedValType}]`} />
    </div>);
  }

  renderOperand2ForFixedText = () => {
    const namespace = this.getConditionalTypeNamespace();
    const conditional = this.props.conditional;
    return (<input 
      className="form-control condition-operand2-input"
      type="text"
      placeholder="enter a text value to match"
      value={conditional.operand2_fixed_text}
      onChange={(event)=>{ this.updateOperand2FixedText(event)}}
      name={`form_rule[${namespace}][${conditional.index}][operand2_fixed_text]`} 
       />);
  }

  renderOperand2ForFormAttributeValue = () => {
    // TODO: this works when matching the selectable values but FAILS when matching another form attribute
    // because the operatorObj is setting the data operand2ValueDataStructureType
    // we allow an array of options when matching selectable options
    // but another form attribute is going to be single select
    const operand1FA = this.props.keenform.form_attributes
      .find(fa => fa.uuid === this.props.conditional.operand1_uuid);
    let matchingValueDataStructureType    = operand1FA.value_data_structure_type;
    let matchingValueType                 = operand1FA.abstract_value_type;
    if (this.props.conditional.operand1_value_type !== "value") {
      const thisMetadataType          = operand1FA.metadata_types
        .find(mdt => mdt.uuid === this.props.conditional.operand1_value_type);
      matchingValueType               = thisMetadataType.abstract_value_type;
    }

    const conditional = this.props.conditional;
    // TODO selectable options should be only single select and freeform (when not filtering rule)
    // MATCH value type of operand1 either value or metadata
    const form_attributes = this.props.keenform.form_attributes;
    const selectableFormAttributes = form_attributes.filter(fa => {
      return INPUT_FORM_ATTRIBUTE_TYPES.includes(fa.form_attribute_type);
    });

    let operatorObj = this.getOperatorObject(conditional.operator); // find operator object
    // if operatorObj has an operand2Type it means the matchingValueType is not the same as operand1 value type
    // i.e. when getting the length of a string you should show number inputs
    if (operatorObj.hasOwnProperty('operand2AbstractValueType') ) {
      if (operatorObj.operand2AbstractValueType !== APP_CONSTANTS.ABSTRACT_VALUE_TYPES.FROM_OPERAND) {
        matchingValueType = operatorObj.operand2AbstractValueType;
      }
    }
    if (operatorObj.hasOwnProperty('operand2ValueDataStructureTypeForAnotherFormAttribute') ) {
      matchingValueDataStructureType = operatorObj.operand2ValueDataStructureTypeForAnotherFormAttribute;
    }

    return <FormAttributeSelectorWithMetadata
      conditional={this.props.conditional}
      index={this.props.conditional.index}
      onUpdateEvent={this.updateOperand2}
      selectableOptions={selectableFormAttributes}
      matchingValueType={matchingValueType}
      matchingValueDataStructureType={matchingValueDataStructureType}
      inputName="operand2"
      val1={conditional.operand2_uuid}
      val2={conditional.operand2_value_type}
      referralValue={conditional.operand1_value_type}
      form_attributes={form_attributes}
      />;
  }

  renderOperand2PreType = () => {
    // if no operand 1 then return undefined
    const namespace = this.getConditionalTypeNamespace();
    const conditional = this.props.conditional;
    if ( !conditional.operand1_uuid || !conditional.operand1_value_type ) {
      return undefined;
    } else if ( !conditional.operator ) { // if operator is not selected
      return undefined;
    }
    
    // else if operator does not require operand 2 return undefined
    const useMetadata = (conditional.operand1_value_type !== "value");
    const operatorOptions = this.getOperatorsPerOperand(useMetadata);
    const operatorObject = operatorOptions.find(operator => {
      return operator.value === conditional.operator
    });

    if (!operatorObject) {
      console.warn('this is not a valid operator');
      return <div className="alert alert-danger">an error has occured</div>;
    } else if (operatorObject.requiresOperand2 === false) {
      console.log('we dont need an operator for this conditional');
      return (<input 
        name={`form_rule[${namespace}][${conditional.index}][operand2_pre_type]`}
        type="hidden" 
        value="none" />);
    }

    // NOW WHAT? - if operand1 or metadata, the comparable value is 
    /**
     * if comparable value is FREEFORM or metadata display type is text or number
     *    if comparable value is value_type === "text" or string
     *      show 'static value' OR all other form attributes that are text
     *    else if comparable value is value_type === "number"
     *      show 'fixed number' or all other form attributes that are text
     *    else
     *       this should not happen
     * else if comparable value is SINGLESELECT OR MULTISELECT
     *    if this selectable does not have options referenced anywhere else for metadata
     *    then hide this and set it 
     */
    const operandOneFA = this.props.keenform.form_attributes.find(fa => fa.uuid === conditional.operand1_uuid);
    let comparableValue = {
      ...operandOneFA,
      object_type: "form_attribute"
    };

    if (conditional.operand1_value_type !== "value") {
      const metadataType = operandOneFA.metadata_types.find(mdt => mdt.uuid === conditional.operand1_value_type);
      comparableValue = {
        ...metadataType,
        object_type: "metadata_type"
      };
    }

    const isFreeformFA = (comparableValue.object_type === "form_attribute" && comparableValue.form_attribute_type === "freeform"),
    isFreeformMetadata = (comparableValue.object_type === "metadata_type" && ['text','number'].includes(comparableValue.display_type));

    const isSelectable = (
      (comparableValue.object_type === "form_attribute" && ["singleselect","multiselect"].includes(comparableValue.form_attribute_type) )
      || (comparableValue.object_type === "metadata_type" && comparableValue.display_type === "singleselect")
    );

    switch (true) {
      case isFreeformFA:
      case isFreeformMetadata:
        const valueType = "text";
        // TODO check value type to verify is number
        return this.renderOperand2TypeForFreeform(comparableValue.value_type);
      // check for single select or multiselect
      case isSelectable:
        // TODO: allow for comparing to either a value that is an option OR
        // if this metadata has a selectable uuid then allow for it to match another form attribute
        return this.renderOperand2TypeForSelectable(comparableValue);
      default:
        console.warn('there is no valid operand 2 to match');
        return <div className="alert alert-warning">an error has occured</div>;
    }
  }

  /**
   * this input should vary depending on Operand1
   * #1 figure out if we are using Form Attribute value OR metadata
   */
  renderOperand2 = () => {
    const conditional = this.props.conditional;
    if (conditional.operand2_pre_type === undefined
      || conditional.operand2_pre_type === null
      || conditional.operand2_pre_type === "none"
      || conditional.operand2_pre_type === PLACEHOLDER_OPTION) {
      return undefined;
    } else {
      switch(conditional.operand2_pre_type) {
        case OPERAND2_PRE_TYPES.FIXED_INTEGER:
        case OPERAND2_PRE_TYPES.FIXED_FLOAT:
          return this.renderOperand2ForFixedNumber();
        case OPERAND2_PRE_TYPES.FIXED_TEXT:
          return this.renderOperand2ForFixedText();
        case OPERAND2_PRE_TYPES.FORM_ATTRIBUTE_VALUE:
          return this.renderOperand2ForFormAttributeValue();
        case OPERAND2_PRE_TYPES.OPTION_VALUE:
          return this.renderOperand2OptionsForSingleSelect();
        case OPERAND2_PRE_TYPES.OPTION_VALUES:
          const operatorObject = this.getOperatorObject(conditional.operator);
          if (!!operatorObject) {
            // TODO: operand2Type is being deprecated, use either operand2AbstractValueType or operand2ValueDataStructureType
            if (operatorObject.operand2Type === APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.SINGLESELECT) {
              return this.renderOperand2OptionsForSingleSelect();
            } else if (operatorObject.operand2Type === APP_CONSTANTS.FORM_ATTRIBUTE_TYPES.MULTISELECT) {
              return this.renderOperand2OptionsForMultiSelect();
            } else {
              console.warn('invalid selector type in renderOperand2');
              return <div className="alert alert-warning">invalid type</div>;
            }
          } else {
            return undefined;
          }
        default:
          console.warn('operand 2 pre type not recognized, conditional: ', conditional);
          return <div className="alert alert-warning">this scenario has not been defined</div>
      }
    }
  }

  renderOperand2Inputs = () => {
    const namespace = this.getConditionalTypeNamespace();
    const conditional = this.props.conditional;
    if (conditional.operand2_pre_type === undefined){
      return <span className="alert alert-warning d-none">no params for operand 2</span>;
    } else {
      if (conditional.operand2_uuid && conditional.operand2_value_type){
        return (<React.Fragment>
          {conditional.operand2_uuid 
          ? <input 
              type="hidden"
              name={`form_rule[${namespace}][${conditional.index}][operand2_uuid]`}
              value={conditional.operand2_uuid} />
          : undefined }
          {conditional.operand2_value_type
          ? <input 
              type="hidden"
              name={`form_rule[${namespace}][${conditional.index}][operand2_value_type]`}
              value={conditional.operand2_value_type} />
          : undefined }
        </React.Fragment>);
      } else {
        return <div className="d-none alert alert-danger">fixed text or fixed number should be saved in hidden input</div>;
      }
    }
  }

  render() {
    return (<div className="form-inline condition-data-container">
      <div className="form-group">
        {this.renderOperand1Select()}
        {this.renderOperand1Inputs()}
      </div>
      <div className="form-group container-condition-input">
        {this.renderOperators()}
      </div>
      <div className="form-group">
        {this.renderOperand2PreType()}
      </div>
      <div className="form-group">
        {this.renderOperand2()}
        {this.renderOperand2Inputs()}
      </div>
    </div>);
  }
}